import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimeNGModule } from '../prime-ng.module';
import { PageComponent } from './page.component';
import { HeaderComponent } from './parts/header/header.component';
import { BottomNavComponent } from './parts/bottom-nav/bottom-nav.component';
import { RouterModule } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';
import { WeatherBannerComponent } from './parts/weather-banner/weather-banner.component';
import { FooterModule } from '../footer/footer.module';
import { CxOneChatbotComponent } from '../../pages/cx-one-chatbot/cx-one-chatbot.component';
import { AriaInjectorDirective } from '../../../directives/aria-injector.directive';
import { FfsBannerModule } from '../ffs-banner/ffs-banner.module';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  declarations: [
    PageComponent,
    HeaderComponent,
    BottomNavComponent,
    MenuComponent,
    WeatherBannerComponent,
    CxOneChatbotComponent,
    AriaInjectorDirective,
  ],
  imports: [
    CommonModule,
    PrimeNGModule,
    RouterModule,
    FooterModule,
    FfsBannerModule,
    LoaderModule
],
  exports: [
    PageComponent,
    HeaderComponent,
    BottomNavComponent,
    MenuComponent,
    AriaInjectorDirective,
  ]
})
export class PageModule { }
